import { Pipe, PipeTransform } from '@angular/core';

import { ServedCustomerSegmentResponse } from '@app/api/marketplace/models';
import { CustomerSegment } from '@shared/interfaces/customer-segments';
import { MerchantType } from '@shared/interfaces/merchant-types';

@Pipe({ name: 'sortMerchantTypes' })
export class SortMerchantTypesPipe implements PipeTransform {
  transform(
    originalList:
      | MerchantType[]
      | CustomerSegment[]
      | ServedCustomerSegmentResponse[]
      | any[],
    attribute?: string
  ): MerchantType[] | CustomerSegment[] | any[] {
    const typesWithOrder = new Map([
      ['MANUFACTURER_OR_IMPORTER_AS_TAX_WAREHOUSE', 1],
      ['MANUFACTURER_OR_IMPORTER_AS_SIMPLIFIED_TAX_WAREHOUSE', 2],
      ['MANUFACTURER_OR_IMPORTER_AS_SMALL_SCALE_WINE_PRODUCER', 3],
      ['INTERNATIONAL_TRADER_AS_REGISTERED_DEALER', 4],
      ['INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER', 5],
      ['INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER', 6],
      ['WHOLESALER_AS_IS', 7],
      ['RETAILER_AS_HOTEL', 8],
      ['RETAILER_AS_RESTAURANT', 9],
      ['RETAILER_AS_CAFE', 10],
      ['RETAILER_AS_RETAIL_CHAIN', 11],
      ['RETAILER_AS_TRAFIK', 12],
      ['RETAILER_AS_OTHER_RETAILER', 13],
      ['END_CONSUMER_AS_IS', 14],
    ]);

    let list = [...originalList];

    if (!attribute) {
      return list.sort(
        (a, b) => (typesWithOrder.get(a) ?? 0) - (typesWithOrder.get(b) ?? 0)
      );
    } else {
      return list.sort(
        (a, b) =>
          (typesWithOrder.get(a[attribute]) ?? 0) -
          (typesWithOrder.get(b[attribute]) ?? 0)
      );
    }
  }
}
